var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.906,
    height: 24.866,
    viewBox: "0 0 67.906 24.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fe0;}.b{fill:#0096db;}.c{fill:#e82717;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.541-206.886a7.306,7.306,0,0,1,2.319-.376,7.318,7.318,0,0,1,7.169,5.854l5.016-1.023a12.437,12.437,0,0,0-12.185-9.949,12.424,12.424,0,0,0-3.941.638Z",
    transform: "translate(-123.427 212.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.818-172.686l3.391-3.834A7.3,7.3,0,0,1,79.74-182a7.294,7.294,0,0,1,2.468-5.477l-3.393-3.833A12.4,12.4,0,0,0,74.622-182,12.4,12.4,0,0,0,78.818-172.686Z",
    transform: "translate(-74.622 194.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M143-118.586a7.317,7.317,0,0,1-7.168,5.846,7.3,7.3,0,0,1-2.321-.377l-1.625,4.855a12.406,12.406,0,0,0,3.946.64,12.438,12.438,0,0,0,12.182-9.938Z",
    transform: "translate(-123.399 132.487)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.607 3.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.222-95.441a4.466,4.466,0,0,1-3.192,1.279,4.433,4.433,0,0,1-2.307-.693l-1.66,2.645a7.529,7.529,0,0,0,3.923,1.166A7.556,7.556,0,0,0,314.4-93.2Z",
    transform: "translate(-301.516 106.219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.829-168.159a7.586,7.586,0,0,0-7.7,7.47,7.541,7.541,0,0,0,1.228,4.259L296.1-162.3a7.591,7.591,0,0,0-7.27-5.855m-4.555,8.057a3.984,3.984,0,0,1-.027-.538,4.466,4.466,0,0,1,4.537-4.4,4.444,4.444,0,0,1,3.34,1.584Z",
    transform: "translate(-281.129 168.16)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.561-191.221v14.65l2.542,1.054-1.2,2.89-2.514-1.045a2.85,2.85,0,0,1-1.238-1.04,3.273,3.273,0,0,1-.486-1.818v-14.69Z",
    transform: "translate(-375.279 191.221)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.273 3.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.369-164.815a4.444,4.444,0,0,1,1.416-.229,4.465,4.465,0,0,1,4.375,3.573l3.062-.624a7.592,7.592,0,0,0-7.437-6.073,7.575,7.575,0,0,0-2.4.389Z",
    transform: "translate(-461.196 168.168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.966-143.941l2.069-2.34a4.453,4.453,0,0,1-1.506-3.345,4.451,4.451,0,0,1,1.505-3.342l-2.071-2.34a7.57,7.57,0,0,0-2.559,5.682A7.568,7.568,0,0,0,433.966-143.941Z",
    transform: "translate(-431.405 157.214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.139-110.92a4.468,4.468,0,0,1-4.375,3.569,4.464,4.464,0,0,1-1.417-.23l-.991,2.963a7.575,7.575,0,0,0,2.409.391,7.594,7.594,0,0,0,7.436-6.066Z",
    transform: "translate(-461.175 119.405)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.bb23283e51f1f6427704c5af9e94272d.svg";
export { ForwardRef as ReactComponent };